import {AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {SlickCarouselComponent} from 'ngx-slick-carousel/slick.component';

@Component({
    selector: 'lib-user-progress',
    templateUrl: './user-progress.component.html',
    styleUrls: ['./user-progress.component.scss']
})
export class UserProgressComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() slides: any[] = [];
    @Input() photoURL: any = null;
    @Input() currentStepIndex = 0;
    @Input() currentStepProgress = 0;

    @ViewChild('slickSteps', {static: false}) slickSteps: SlickCarouselComponent | null = null;
    currentSlide = 0;
    config: any = {};

    constructor() {
    }

    afterChange(e: any) {
        this.currentSlide = e.currentSlide;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.currentStepIndex && changes.currentStepIndex.currentValue) {
            this.currentStepIndex = changes.currentStepIndex.currentValue;
            this.updateState();
        }
        if (changes && changes.currentStepProgress && changes.currentStepProgress.currentValue) {
            this.currentStepProgress = changes.currentStepProgress.currentValue;
            this.updateState();
        }
    }

    ngOnInit(): void {
        this.slides = [
            {
                stepNumber: 1,
                stepTitle: 'Дослідник',
                isLocked: false,
                levelCompleted: true,
                totalSessions: 7,
                currentStepProgress: 100,
                content: 'Ласкаво просимо до спільноти людей, які прагнуть зрозуміти та підтримувати свій психічний добробут. Регулярно використовуючи Anima, ви не лише поглиблюєте розуміння своїх психічних станів, але й зміцнюєте свою здатність обирати найефективніші стратегії подолання труднощів, дбайливіше підтримувати внутрішню рівновагу.' +
                    '<br>' +
                    'Тривога чи пригнічений настрій часто змушують нас фокусуватися на негативних думках, створюючи замкнене коло. Anima використовує технологію відстеження рухів очей, щоб виявити ці патерни та допомогти вам їх усвідомити. Це перший крок до розриву цього циклу та формування здоровіших ментальних звичок.' +
                    '<br>' +
                    'Щоб налаштувати персоналізований прогрес в Anima, спробуйте пройти перші 6 сесій протягом тижня. Такий ритм допоможе системі зрозуміти нюанси ваших психічних реакцій і настрою. Експериментуйте, проходячи тести у різний час доби та за різних емоційних станів – це збагатить ваші інсайти та створить чіткішу карту вашого внутрішнього світу. Ця подорож – не змагання, а діалог із собою. Ваші старання – це зерно, що дає паростки мудрості, а кожен ваш рух вперед – це плекання саду вашого внутрішнього спокою.'
            },
            {
                stepNumber: 2,
                stepTitle: 'Спостерігач',
                totalSessions: 14,
                isLocked: false,
                levelCompleted: true,
                currentStepProgress: 100,
                content: 'Ви досягли стану більшого розуміння власного внутрішнього світу! Тепер ви чітко бачите, як ваш розум реагує в різних обставинах. Можливо, ви відчуваєте гіперпильність – схильність залишатися на високій готовності, або уникання, коли хочеться оминути щось неприємне, або ж для цього просто немає ресурсу. Можливо, ви помітили ознаки ангедонії, коли позитивні враження втратили свою яскравість, або ж дисфорії, коли увага застряє на негативі й роздратування стає постійним. Ці шаблони – цінні підказки до того, як працює ваш розум.' +
                    '<br>' +
                    'Ваш наступний крок – спостерігати: які події чи дії впливають на ваші показники Anima? Спробуйте записувати, як значні зміни у вашому настрої відображаються на психічному здоров’ї в балах за тестами. Що працює для вас? Що допомагає відновити рівновагу? Цей процес допоможе пов’язати ваші емоційні шаблони з тим, що підтримує ваш добробут, і створити міцнішу основу для зростання.'
            },
            {
                stepNumber: 3,
                stepTitle: 'Майстер Рівноваги',
                totalSessions: 14,
                levelCompleted: false,
                currentStepProgress: 0,
                isLocked: false,
                content: 'Ви досягли етапу, коли можете свідомо формувати та регулювати свої емоційні реакції. Ви вже бачили, як події у вашому житті та щоденні звички відображаються на вашій психіці. Тепер час застосувати набуті навички, відкоригувати баланс між роботою та відпочинком, використовувати стратегії, які ви засвоїли, для досягнення стабільності. Навіть невеликі зміни можуть мати великий вплив.' +
                    '<br>' +
                    'Саморегуляція перетворює інсайти на дії. Наприклад, якщо ви помітили, що соціальні взаємодії залишають вас виснаженими, ви можете планувати короткі перерви після них для відновлення енергії. Кожна свідома звичка зміцнює вашу здатність долати виклики з ясністю та впевненістю. Використовуйте цей етап, щоб натренувати те, що працює для вас, і розвивати стійкість, яка триватиме все життя.'
            },
            {
                stepNumber: 4,
                stepTitle: 'Командний гравець',
                totalSessions: 14,
                levelCompleted: false,
                currentStepProgress: 0,
                isLocked: true,
                content: 'Розвиваючи навички саморегуляції, ви можете помітити, як знання про свій стан покращує ваші взаємодії з іншими. Anima допомагає помічати, як працюють ваші емоції та увага, надаючи інструменти для більш усвідомленого й збалансованого підходу до стосунків. На цьому етапі ми заохочуємо вас запросити людей, яких ви любите, приєднатися до Anima та почати ділитися своїми результатами й інсайтами з вами.' +
                    '<br>' +
                    'Порівнюючи висновки чи обговорюючи, як кожен із вас долає труднощі, ви створюєте спільну мову для розвитку. Ця подорож зміцнює зв’язки, сприяє довірі та створює більш підтримуюче середовище, де кожен може процвітати. Психічне здоров’я – це не лише особиста справа, воно глибоко залежить від добробуту наших близьких та нашого спільного соціального середовища.'
            },
            {
                stepNumber: 5,
                stepTitle: 'Підтримувач',
                totalSessions: 14,
                levelCompleted: false,
                currentStepProgress: 0,
                isLocked: true,
                content: 'На цьому етапі ви починаєте розуміти, наскільки ваш добробут тісно пов’язаний із вашим оточенням. Тепер ви можете активно використовувати свої знання, щоб знайти баланс у стосунках з оточенням. Досліджуйте, як ваші внутрішні патерни впливають на соціальну динаміку і як вона впливає на вас. Наприклад, якщо ви помічаєте, що під час обговорень у команді у вас посилюється гіперпильність, спробуйте визначити, які фактори її спричинили. Це може бути відсутність ясності, тон розмови або специфічні теми. Усвідомлення цих чинників  допоможе краще зрозуміти свої емоції та реакції.' +
                    '<br>' +
                    'Якщо дисфорія змушує вас уникати соціальних контактів, спробуйте проаналізувати реакції інших та хід вашого спілкування. Цей етап заохочує вас не лише аналізувати власний досвід, але й враховувати перспективи тих, з ким ви взаємодієте, сприяючи глибшому розумінню взаємодинаміки та емоційного балансу.'
            },
            {
                stepNumber: 6,
                stepTitle: 'Майстер гармонії',
                totalSessions: 14,
                levelCompleted: false,
                currentStepProgress: 0,
                isLocked: true,
                content: 'Ви досягли етапу, коли усвідомленість стає дієвою, допомагаючи вам не лише регулювати власні емоційні стани, але й позитивно впливати на добробут інших. Зараз саме час застосувати отримані знання для активного управління своїми реакціями та створення підтримуючого середовища. Наприклад, якщо ви помічаєте, що прагнете оминути розмови, зробіть невеликий, але свідомий крок, щоб залишатися залученим – поставте питання, що вас турбує, або чітко висловіть своє ставлення до предмету розмови.' +
                    '<br>' +
                    'Також, якщо ви помітили, що ваш друг проявляє сильне невдоволення чи роздратування, спробуйте допомогти їм поглянути на ситуацію з іншої точки зору, припустивши, що це може бути пов’язане з їхнім поточним психічним станом. Наприклад, підвищена дисфорія може посилювати негативні емоції, через що навіть незначні неприємності здаються надмірно складними.'
            },
            {
                stepNumber: 7,
                stepTitle: 'Візіонер',
                totalSessions: 14,
                levelCompleted: false,
                currentStepProgress: 0,
                isLocked: true,
                content: 'На цьому етапі ви, ймовірно, усвідомили, що увага – це важливий ресурс для вашого психічного добробуту та розвитку. Те, як і куди ви спрямовуєте свою увагу, формує ваше самопочуття: або покращує його, або виснажує, якщо увага спрямована на негативне. Зараз час свідомо керувати своєю увагою та навчитися спрямовувати її цілеспрямовано.' +
                    '<br>' +
                    'Зміна вашого ставлення до звичних труднощів може допомогти знайти ефективніші способи їх подолання. Наприклад, якщо ви відчуваєте напруження в очікуванні невизначеного результату, ваша увага може інстинктивно зосередитися на найгіршому сценарії. Хоча це може здаватися підготовкою, насправді це лише посилює стрес і підриває вашу здатність ефективно реагувати. Натомість зробіть паузу і запитайте себе: «Що ще це може означати?». Відпрацьовуючи цю навичку, ви зможете спрямовувати увагу на варіанти, які надають вам сили, розвиваючи стійкість і підтримуючи психічний добробут.' +
                    '<br>' +
                    'Переосмислення реальності – це спосіб знайти підходи, що додають енергії, а не створюють обмеження. Йдеться про те, щоб побачити у проблемі можливість для розвитку, навчання або конструктивної підготовки. Ця практика розвиває психологічну гнучкість, допомагаючи вам подолати невизначеність. Віддаючи перевагу конструктивним точкам зору, ви зміцнюєте свої позиції для успіху та зменшуєте емоційне навантаження, концентруючись, на справді, важливих речах.'
            }
        ];

        this.updateState();
        this.config = {
            variableWidth: false,
            variableHeight: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            animation: false,
            infinite: false,
            initialSlide: this.currentSlide
        };
    }

    updateState() {
        this.slides.forEach((slide: any) => {
            if (slide.stepNumber < this.currentStepIndex) {
                slide.isLocked = false;
                slide.levelCompleted = true;
            } else if (slide.stepNumber === this.currentStepIndex) {
                slide.isLocked = false;
                slide.levelCompleted = false;
            } else {
                slide.isLocked = true;
                slide.levelCompleted = false;
            }
        });
        this.slickSteps?.slickGoTo(this.currentStepIndex - 1);

    }

    ngAfterViewInit() {
    }

    activeSession(totalSessions: number, currentStepProgress: number) {
        return +Math.floor(totalSessions * (currentStepProgress / 100)).toFixed();
    }

    arrFromNumber(i: number) {
        const arr = [];
        for (let j = 0; j < i; j++) {
            arr.push(j);
        }
        return arr;
    }
}
